/**
 * gbi-marquee — enhancer over pure-CSS marquee tracks.
 *
 * Usage: <div data-marquee data-marquee-speed="40" data-marquee-pause-on-hover>
 *          <div class="marquee-track">...</div>
 *        </div>
 *
 * - Duplicates track contents once (seamless loop on translateX(-50%))
 * - Pauses CSS animation when off-screen
 * - Optional pause on hover
 * - prefers-reduced-motion: freezes track at start
 */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function attach(container) {
    const track = container.querySelector('.marquee-track');
    if (!track) return;

    const speed = parseFloat(container.dataset.marqueeSpeed) || 40;
    const trackWidth = track.scrollWidth;
    const duration = Math.max(8, trackWidth / speed);
    container.style.setProperty('--gbi-marquee-duration', `${duration}s`);

    const children = Array.from(track.children);
    children.forEach((c) => {
      const clone = c.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    if (reduceMotion) {
      track.style.animation = 'none';
      track.style.transform = 'translateX(0)';
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          track.classList.toggle('is-paused', !entry.isIntersecting);
        });
      },
      { threshold: 0.01 }
    );
    io.observe(container);

    if (container.hasAttribute('data-marquee-pause-on-hover')) {
      container.addEventListener('mouseenter', () => track.classList.add('is-paused'));
      container.addEventListener('mouseleave', () => track.classList.remove('is-paused'));
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-marquee]:not([data-marquee-init])').forEach((el) => {
      el.setAttribute('data-marquee-init', '');
      attach(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  window.GBI = window.GBI || {};
  window.GBI.marquee = { init };
})();
